import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTheme } from "./Theme/Themecontext";
import { initializeCeoInboxItems } from "./Jsonsidebar";
import { useTranslation } from "react-i18next";
import { useInbox } from "../components/InboxProvider/InboxProvider";
import Loader from "../common/Loader";

function CeoInbox() {
  const { t } = useTranslation();
  const { styles } = useTheme();
  const { component } = styles;
  const { refreshTrigger } = useInbox();

  const [ceoInboxItem, setCeoInboxItem] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleRefresh = () => {
    window.location.reload();
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const items = await initializeCeoInboxItems();
      setCeoInboxItem(items);
    } catch (error) {
      console.error("Failed to fetch inbox items:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [refreshTrigger]); // Re-fetch when refreshTrigger changes

  return (
    <div className="p-5 md:border-hidden md:p-0 md:bg-transparent border-[1px] border-opacity-[50%] border-[#787878] rounded-[10px] h-full">
      <div className="mb-2 md:hidden flex justify-between">
        <p className="text-[#1E3354] text-[16px] font-[600]">Inbox</p>
        <button onClick={handleRefresh}>
          <span className="material-symbols-outlined">refresh</span>
        </button>
      </div>
      <div className="flex">
        <div className="flex flex-wrap mx-2 gap-2 mt-3">
          {isLoading ? (
            <div><Loader/></div>
          ) : (
            ceoInboxItem.map((item, index) => (
              <Link to={item.link} key={index}>
                <div
                  style={component}
                  className="relative flex flex-col justify-center items-center darkshadow p-2 h-[50px] lg:w-[100px] xl:w-[150px] rounded-[10px]"
                >
                  <span className="text-[12px] text-center">
                    {t(`ceoInboxItem.${item.label}`)}
                  </span>
                  {item.count > 0 && (
                    <div className="absolute -top-2 -right-1.5 w-[25px] h-[20px] rounded-full bg-[#FAA1AB] text-[#FC1F38]">
                      <p className="text-[10px] text-center mt-0.5">
                        {item.count ?? 0}
                      </p>
                    </div>
                  )}
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default CeoInbox;